/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { ConsumableCategory } from 'app/shared/model/enumerations/consumable-category.model';
import { createEntity, getEntity, reset, updateEntity } from './consumable-group.reducer';

export const ConsumableGroupUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const consumableGroupEntity = useAppSelector(state => state.consumableGroup.entity);
  const loading = useAppSelector(state => state.consumableGroup.loading);
  const updating = useAppSelector(state => state.consumableGroup.updating);
  const updateSuccess = useAppSelector(state => state.consumableGroup.updateSuccess);
  const consumableCategoryValues = Object.keys(ConsumableCategory);

  const handleClose = () => {
    navigate(`/consumable-group${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }

    const entity = {
      ...consumableGroupEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          category: 'ABLATION_DEVICE',
          ...consumableGroupEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.consumableGroup.home.createOrEditLabel" data-cy="ConsumableGroupCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.consumableGroup.home.createOrEditLabel">Create or edit a ConsumableGroup</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="consumable-group-id"
                  label={translate('tinyMedicRestApp.consumableGroup.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.consumableGroup.category')}
                id="consumable-group-category"
                name="category"
                data-cy="category"
                type="select"
              >
                {consumableCategoryValues.map(consumableCategory => (
                  <option value={consumableCategory} key={consumableCategory}>
                    {translate(`tinyMedicRestApp.ConsumableCategory.${consumableCategory}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.consumableGroup.addedBy')}
                id="consumable-group-addedBy"
                name="addedBy"
                data-cy="addedBy"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.consumableGroup.deviceTypeName')}
                id="consumable-group-deviceTypeName"
                name="deviceTypeName"
                data-cy="deviceTypeName"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.consumableGroup.riskClass')}
                id="consumable-group-riskClass"
                name="riskClass"
                data-cy="riskClass"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.consumableGroup.generalIntendedUse')}
                id="consumable-group-generalIntendedUse"
                name="generalIntendedUse"
                data-cy="generalIntendedUse"
                type="text"
                validate={{
                  maxLength: { value: 3000, message: translate('entity.validation.maxlength', { max: 3000 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.consumableGroup.timestampentry')}
                id="consumable-group-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.consumableGroup.active')}
                id="consumable-group-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.consumableGroup.lastupdated')}
                id="consumable-group-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.consumableGroup.cursor')}
                id="consumable-group-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.consumableGroup.microSec')}
                id="consumable-group-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/consumable-group" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ConsumableGroupUpdate;
